

import React, { useState } from "react";
import { Card, CardContent, CardHeader } from "@mui/material";
import { List, ListItem, ListItemText, IconButton } from "@mui/material";
import { Phone } from "@mui/icons-material";
import "bootstrap/dist/css/bootstrap.min.css";

const doctors = [
  { id: 1, name: "Dr. John Doe", phone: "+1234567890" },
  { id: 2, name: "Dr. Jane Smith", phone: "+0987654321" },
];

const EmergencyPage: React.FC = () => {
  const [messages, setMessages] = useState<{ sender: string; text: string }[]>([]);
  const [input, setInput] = useState("");

  const sendMessage = () => {
    if (input.trim()) {
      setMessages([...messages, { sender: "You", text: input }]);
      setInput("");
    }
  };

  return (
    <><div className="container mt-4">
      {/* Live Chat */}
      {/* <Card className="mb-4">
        <CardHeader title="Live Chat" />
        <CardContent className="overflow-auto" style={{ maxHeight: "300px" }}>
          <List>
            {messages.map((msg, index) => (
              <ListItem key={index} className="bg-light rounded p-2 mb-2">
                <ListItemText primary={<strong>{msg.sender}:</strong>} secondary={msg.text} />
              </ListItem>
            ))}
          </List>
        </CardContent>
        <CardContent className="d-flex gap-2">
          <TextField
            fullWidth
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type a message..."
            variant="outlined" />
          <Button variant="contained" color="primary" onClick={sendMessage}>
            <Message /> Send
          </Button>
        </CardContent>
      </Card> */}

      {/* Doctor Contact List */}
      <Card>
        <CardHeader title="Doctor Contacts" />
        <CardContent>
          <List>
            {doctors.map((doc) => (
              <ListItem key={doc.id} className="d-flex justify-content-between border rounded p-2 mb-2">
                <ListItemText primary={doc.name} />
                <IconButton color="primary" component="a" href={`tel:${doc.phone}`}>
                  <Phone />
                </IconButton>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
    </div></>
  );
};

export default EmergencyPage;
